import { render, staticRenderFns } from "./BasicData.vue?vue&type=template&id=7879401a&"
import script from "./BasicData.vue?vue&type=script&lang=js&"
export * from "./BasicData.vue?vue&type=script&lang=js&"
import style0 from "./BasicData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BasicData.vue"
export default component.exports